import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Users, Trophy } from "lucide-react";

export default function JoinLeague() {
  const { code } = useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [league, setLeague] = useState(null);
  const [err, setErr] = useState(null);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      // Save intent to sessionStorage and redirect to login
      sessionStorage.setItem("post_login_redirect", `/join/${code}`);
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUrl = window.location.origin + `/join/${code}`;
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
      return;
    }
    (async () => {
      try {
        const { data } = await api.get(`/leagues/by-code/${code.toUpperCase()}`);
        setLeague(data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Ligaen blev ikke fundet");
      }
    })();
  }, [code, user, loading]);

  const doJoin = async () => {
    setJoining(true);
    try {
      const { data } = await api.post(`/leagues/by-code/${code.toUpperCase()}/join`);
      toast.success(data.already_member ? "Du er allerede medlem" : "Joinede liga!");
      navigate(`/leagues/${data.league_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kunne ikke joine");
    } finally { setJoining(false); }
  };

  if (loading || (!user)) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Logger dig ind…</div>;

  return (
    <div className="max-w-xl mx-auto px-4 py-24">
      {err && (
        <div className="card-flat p-8 text-center">
          <div className="text-red-400 font-semibold mb-2">Ups</div>
          <div className="text-zinc-400">{err}</div>
          <Link to="/hjem" className="inline-block mt-6"><Button className="bg-white text-black">Til forsiden</Button></Link>
        </div>
      )}
      {league && (
        <div className="card-flat p-8">
          <div className="label-eyebrow">Du er inviteret</div>
          <h1 className="hero-title text-4xl mt-2" data-testid="join-league-name">{league.name}</h1>
          <div className="mt-4 flex items-center gap-4 text-sm text-zinc-400">
            <span className="flex items-center gap-1"><Users size={12} /> {league.member_count} medlem{league.member_count === 1 ? "" : "mer"}</span>
            <span>Oprettet af {league.owner_name}</span>
          </div>
          <p className="mt-6 text-zinc-400">Konkurrer i denne private liga. Din score fra alle festivaler tælles med.</p>
          <div className="mt-8 flex gap-3">
            {league.is_member ? (
              <Link to={`/leagues/${league.league_id}`}>
                <Button className="bg-white text-black hover:bg-zinc-200" data-testid="join-goto-btn">
                  <Trophy size={12} className="mr-1" /> Se leaderboard
                </Button>
              </Link>
            ) : (
              <Button onClick={doJoin} disabled={joining} className="bg-white text-black hover:bg-zinc-200" data-testid="join-confirm-btn">
                {joining ? "Joiner…" : "Join liga"}
              </Button>
            )}
            <Link to="/hjem"><Button variant="outline">Annuller</Button></Link>
          </div>
        </div>
      )}
    </div>
  );
}
